/**
 * @file 标记他人号码
 * @author
 */

import React, {useEffect, useState} from 'react';
// import {connect} from 'react-redux';
// import {withRouter} from 'react-router-dom';
// import PropTypes from 'prop-types';
// import {Button, Carousel, Modal, Select, Radio, Space, Input, message} from 'antd';
import {getQueryString, bCat_2055_request, recordProxy} from '../../util';
import NumErr from './numErr';
import MarkErr from './markErr';

export default function ErrPage(props) {
    const [pageType, setPageType] = useState('numErr');
    useEffect(() => {
        const searchUrlPhones = getQueryString('phones');
        const searchUrlPhone = getQueryString('phone');
        if (searchUrlPhones) {
            setPageType('numErr');
        } else if (searchUrlPhone) {
            setPageType('markErr');
        }
    }, []);
    return (<div>
        {pageType === 'numErr' && <NumErr />}
        {pageType === 'markErr' && <MarkErr />}
    </div>);
}